import React, { ReactElement, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Translate } from "react-redux-i18n";
import { BottomNavigation, Paper, Typography, Box, Badge } from "@mui/material";
import { NAVIGATION_SECTIONS } from "../constants";
import { toggleMobileCouponDrawer } from "redux/coupon/couponSlice";
import Info from "../../../assets/images/header/info.svg";

import styles from "./styles.module.scss";
import { toggleFooter } from "redux/navigation/navigationSlice";

export default function FixedBottomNavigation(): ReactElement {
  const dispatch = useAppDispatch();
  const activeRoute = useAppSelector((state) => state.navigation.activeRoute);
  const isCouponMobileVisible = useAppSelector(
    (state) => state.coupon.isCouponMobileVisible
  );
  const maxodd = useAppSelector((state) => state.coupon.maxOdd);
  const couponLength = useAppSelector((state) => state.coupon.couponLength);

  const images = require.context(
    "assets/images/header",
    true,
    /\.(png|ico|svg|jpg|gif)$/
  );

  const [value, setValue] = React.useState(0);
  const [updatedMaxOdd, setUpdatedMaxOdd] = useState<number | string>(0);

  const handleCouponClick = () => {
    dispatch(toggleMobileCouponDrawer(true));
  };

  useEffect(() => {
    maxodd && setUpdatedMaxOdd(maxodd.toFixed(2));
  }, [maxodd]);
  const filteredItems =
    process.env.REACT_APP_HIDE_LIVE_SPORT === "true" ?
      NAVIGATION_SECTIONS.filter(item => !item.isHideable)
      :
      NAVIGATION_SECTIONS;
  return (
    <Paper
      className={[styles.bottombar, "app-bottom-navigation"].join(" ")}
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        className={styles.bottomNavigation}
      >
        {filteredItems?.map((item, index) => (
          <Box
            key={index}
            className={`
            ${item.visibleFor === "desktop"
                ? styles.displayForDesktop
                : item.visibleFor === "mobile"
                  ? styles.displayForMobile
                  : styles.sectionLinkContainer
              }
                `}
          >
            {item.isRoute ? (
              <Box
                component={Link}
                to={item.path}
                onClick={() =>
                  activeRoute === 2 && document.body.scrollTo(0, 0)
                }
                className={`${styles.sectionLink} ${activeRoute === item.id && styles.activeSectionLink
                  }
                ${process.env.REACT_APP_HEADER_VERSION === "version2" &&
                  activeRoute === item.id &&
                  styles.activeSectionLinkBackground
                  }
                `}
              >
                {item.id === 6 && couponLength > 0 && (
                  <Badge color="primary" max={99} className={styles.badge}>
                    <Typography className={styles.couponLength}>
                      {couponLength}
                    </Typography>
                  </Badge>
                )}

                {item.isIcon &&
                  <img
                    src={images(`./${item.section}.svg`).default}
                    alt=""
                    className={`${styles.sectionLinkImg}`}
                  />
                }

                {process.env.REACT_APP_HEADER_VERSION === "version2" && (
                  <Typography className={`${styles.sectionLinkText} `}>
                    {item.label}
                  </Typography>
                )}

                {item.id === 6 && (
                  <>
                    {!maxodd || maxodd === 1 || maxodd === 0 ? (
                      <></>
                    ) : (
                      <Typography className={`${styles.sectionLinkText} `}>
                        <Translate value="nav.couponOdd" />:{updatedMaxOdd}
                      </Typography>
                    )}
                  </>
                )}
              </Box>
            ) : (
              <Box
                onClick={() => handleCouponClick()}
                className={`${styles.sectionLink} ${isCouponMobileVisible && styles.activeSectionLink
                  }`}
              >
                {item.id === 6 && couponLength > 0 && (
                  <Badge color="primary" max={99} className={styles.badge}>
                    <Typography className={styles.couponLength}>
                      {couponLength}
                    </Typography>
                  </Badge>
                )}

                {item.isIcon &&
                  <img
                    src={images(`./${item.section}.svg`).default}
                    alt={item.section}
                    className={`${styles.sectionLinkImg}`}
                  />}
                {item.id === 6 && (
                  <>
                    {!maxodd || maxodd === 1 || maxodd === 0 ? (
                      <Typography className={`${styles.sectionLinkText} `}>
                        {process.env.REACT_APP_HEADER_VERSION === "version2" &&
                          item.label}
                      </Typography>
                    ) : (
                      <Typography className={`${styles.sectionLinkText} `}>
                        <Translate value="nav.couponOdd" />:{updatedMaxOdd}
                      </Typography>
                    )}
                  </>
                )}
              </Box>
            )}
          </Box>
        ))}

        {process.env.REACT_APP_BETUN_FOOTER && (
          <Box
            onClick={() => dispatch(toggleFooter(true))}
            className={styles.sectionLinkContainer}
          >
            <Box className={styles.sectionLink}>
              <img src={Info} alt="" className={styles.sectionLinkImg} />
            </Box>
          </Box>
        )}
      </BottomNavigation>
    </Paper>
  );
}
